import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LanguageService } from '../language/language.service';
import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class PostsService {

  constructor(private http: HttpClient, private languageService: LanguageService) {}

  /**
   * ყველა მენიუ
   */
  getMenus() {
    return this.http.get(`${environment.apiUrl}menus`);
  }

  /**
   * კონკრეტული მენიუ page-ის მიხედვით
   */
  getMenu(page: number) {
    return this.http.get(`${environment.apiUrl}menu/${page}`);
  }

  /**
   * ჩამოტანა ყველა list ტიპის გვერდის (listPages)
   */
  getListPages(params: any = {}) {
    const lang = this.languageService.getLanguage();
    return this.http.get(`${environment.apiUrl}admin/list`, { params: { ...params, lang } });
  }
  /**
   * ჩამოტანა კონკრეტული list-ის გვერდების/სიახლეების menu_page-ის მიხედვით
   */
  getPageByItems(params: any) {
    const lang = this.languageService.getLanguage();
    return this.http.get(`${environment.apiUrl}admin/list`, {
      params: { ...params, lang }
    });
  }

  /**
   * პოსტის წაშლა (Admin)
   */
  delete(id: number = 0){
    return this.http.delete(`${environment.apiUrl}admin/list/delete/${id}`);
  }


  toggleVisible(id: number, lang: string) {
    return this.http.post<any>(`${environment.apiUrl}admin/list/${id}/toggle-visible`, { lang });
  }



}